<<template>
  <div id="pagerPanel" class="pager-panel form-inline">
    <ul class="nav navbar-nav navbar-left">
      <li class="nav-system">
          <span class="glyphicon glyphicon-option-vertical"></span>
      </li>
      <li :class='[isFirst? "nav-system": "nav-system disabled"]'>
          <a href="javascript:" v-on:click="first" :title='rs["pager_btn_first"]'><span class="glyphicon glyphicon-step-backward"></span></a>
      </li>
      <li :class='[isPre? "nav-system": "nav-system disabled"]'>
          <a href="javascript:" v-on:click="prep" :title='rs["pager_btn_pre"]'><span class="glyphicon glyphicon-triangle-left"></span></a>
      </li>
      <li class="nav-system">
          <input type="text" id="txtPageNo" :title='rs["pager_pageNo"]' v-on:change.stop="pageNoChange" v-model="pageNo" class="pager-input" style="width: 60px;">
          <span >/</span> <span :title='rs["pager_pageCount"]' style="height: 18px;">{{pageCount}}</span>
      </li>
      <li  :class='[isNext? "nav-system": "nav-system disabled"]'>
          <a href="javascript:" v-on:click="next" :title='rs["pager_btn_next"]'><span class="glyphicon glyphicon-triangle-right"></span></a>
      </li>
      <li  :class='[isLast? "nav-system": "nav-system disabled"]'>
          <a href="javascript:" v-on:click="last" :title='rs["pager_btn_last"]'><span class="glyphicon glyphicon-step-forward"></span></a>
      </li>
      <li>
          <input type="text" id="txtPageSize" v-on:change.stop="pageSizeChange" v-model="pageSize" class="pager-input" style="width: 60px;" :title='rs["pager_pageSize"]'>
          <span style="height: 18px; width: 65px;">/</span>
          <label :title='rs["pager_rowCount"]' class="pager-rowqty" style="width: 44px; z-index: 0">{{crowCount}}</label>
      </li>

      <li v-if='rights("View")' :class='selOneClass'>
        <a href="javascript:" @click='$emit("CFHandler", "view")' :title='rs["View"]'><span :class='rs["icon_view"]'></span></a>
      </li>
      <li v-if='rights("Copy")' :title='rs["Copy"]' :class='selOneClass'>
        <a href="javascript:" @click='$emit("CFHandler", "copy")'><span :class='rs["icon_copy"]'></span></a>
      </li>
      <li v-if='rights("Add")' :title='rs["Add"]' class="nav-system">
        <a href="javascript:" @click='$emit("CFHandler", "add")'><span :class='rs["icon_add"]'></span></a>
      </li>
      <li v-if='rights("Edit")' :title='rs["Edit"]' :class='getActionClass("Edit")'>
        <a href="javascript:" @click='$emit("CFHandler", "edit")'><span :class='rs["icon_edit"]'></span></a>
      </li>
      <li v-if='rights("Delete")' :title='rs["Delete"]' :class='getActionClass("Delete")'>
        <a href="javascript:" @click='$emit("CFHandler", "delete")'><span :class='rs["icon_delete"]'></span></a>
      </li>

      <li v-if='rights("Import")' :title='rs["Import"]' class="nav-system">
        <a href="javascript:" @click='$emit("CFHandler", "import")'><span :class='rs["icon_import"]'></span></a>
      </li>
      <li v-if='rights("Export")' :title='rs["Export"]' class='dropdown'>
        <a href="javascript:" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
          <span :class='rs["icon_export"]'></span><span class="caret"></span></a>
          <ul class="dropdown-menu">
            <li v-if='rights("exportToExcel")'><a href="#" @click='$emit("CFHandler", "exportToExcel")'><span :class='rs["icon_excel"]'>&nbsp;</span>Excel</a></li>
            <li v-if='rights("exportToExcel")'><a href="#" @click='$emit("CFHandler", "exportToExcel2003")'><span :class='rs["icon_excel"]'>&nbsp;</span>Excel2003</a></li>
            <li v-if='rights("exportToWord")'><a href="#" @click='$emit("CFHandler", "exportToWord")'><span :class='rs["icon_word"]'>&nbsp;</span>Word</a></li>
            <li v-if='rights("exportToWord")'><a href="#" @click='$emit("CFHandler", "exportToWord2003")'><span :class='rs["icon_word"]'>&nbsp;</span>Word2003</a></li>
            <li v-if='rights("exportToPDF")'><a href="#" @click='$emit("CFHandler", "exportToPDF")'><span :class='rs["icon_pdf"]'>&nbsp;</span>PDF</a></li>
            <slot name="export"></slot>
          </ul>
      </li>

      <slot></slot>
      
    </ul>
 </div>
</template>

<<script>

export default {
  //updated() {
  //  console.log("pagePanel.created")
  //},
  props:["rightList","crowCount", "cpageNo", "cpageSize", "isAdd", "isExport","selIdx", "config"],
  data() {
      return {ps: 18, pn: 1, rs:this.$rs, selOneClass: "nav-system disabled" }
  },
  computed: {
    isFirst: function() {
      if (this.pageNo <= 1) return false;
      else return true;
    },
    isPre: function() {
      if (this.pageNo <= 1) return false;
      else return true;
    },
    isNext: function() {
      if (this.pageNo >= this.pageCount) return false;
      else return true;
    },
    isLast: function() {
      if (this.pageNo >= this.pageCount) return false;
      else return true;
    },
    pageCount: function() {
      let pc = parseInt(this.crowCount/ this.pageSize);
      if (this.crowCount % this.pageSize > 0) pc++;
      return pc;
    },
    pageNo: {
      get: function() {
        return this.cpageNo;
      },
      set: function(dt) {
        this.pn = dt;
      }
    },
    pageSize: {
      get: function() {
        return this.cpageSize;
      },
      set: function(dt) {
        this.ps = dt;
      }
    }
  },
  methods: {
    getActionClass(action){
      if (!this.config || !this.config.customActionState || !this.config.customActionState[action]) return this.selOneClass
      return this.config.customActionState[action].call(this, this.selIdx, this.config) ? "nav-system":"nav-system disabled"
    },
    CFHandler(xfunc){
      this.$emit("CFHandler", xfunc)
    },
    pageNoChange: function() {
      this.$emit("CFHandler", 'loadData', this.pn)
    },
    pageSizeChange: function() {
      this.$emit("CFHandler", 'pageSizeChange', this.ps)
    },
    next: function() {
      if (this.isNext) this.$emit("CFHandler", 'loadData', this.pageNo + 1)
    },
    prep: function() {
      if (this.isPre) this.$emit("CFHandler", 'loadData', this.pageNo - 1)
    },
    first: function() {
      if (this.isFirst) this.$emit("CFHandler", 'loadData', 1)
    },
    last: function() {
      if (this.isLast) this.$emit("CFHandler", 'loadData', -1)
    }
  },
  watch:{
    selIdx(){
      this.selOneClass = typeof this.selIdx == "number"? "nav-system":"nav-system disabled"
    }
  }
}
</script>
